import React from "react";
import { Link } from "react-router-dom";
import blogFeaturedImage from "../assets/312241.jpg";
import blogCard from "../assets/hand-adding-coins-stack-covered-dirt-plants.jpg";
import blogCardCity from "../assets/65203.jpg";
import blogCardFamily from "../assets/side-view-man-woman-meditating-outdoors-yoga-mats.jpg";
import blogCardMap from "../assets/construction-concept-engineering-tools.jpg";
import blogCardHouse from "../assets/2148301697.jpg";
import blogCardModel from "../assets/3d-map-with-detailed-travel-routes-immersive-navigation-visuals.jpg";

const posts = [
  {
    title: "Insights That Can Save or Make Your Investment.",
    path: "/blog/insights",
    image: blogCard,
  },
  {
    title:
      "Key Factors to Consider Before Investing in a Residential Property",
    image: blogCardCity,
  },
  {
    title: "Luxury Living Explained: What Truly Defines a Premium Home",
    image: blogCardFamily,
  },
  {
    title:
      "From Blueprint to Reality: Understanding the Home Construction Journey",
    image: blogCardMap,
  },
  {
    title:
      "Why Location, Planning, and Quality Matter in Real Estate Investments",
    image: blogCardHouse,
  },
  {
    title: "Knowledge That Covers Every Step of Your Property Journey",
    image: blogCardModel,
  },
];

function BlogListPage() {
  return (
    <main>
      <section className="page-hero blog-hero">
        <div className="container">
          <h1 className="section-title center" style={{marginBottom: '0px'}}>
            Discover our <span>latest Blog</span>
          </h1>
        </div>
      </section>

      <section className="section blog-list-section">
        <div className="container">
        <article className="blog-featured">
          <Link to="/blog/insights" className="blog-featured-image">
            <img src={blogFeaturedImage} alt="Featured blog" />
            <div className="blog-featured-overlay">
              <h2>Insights That Can Save or Make <br></br><span>Your Investment.</span></h2>
              <p className="blog-meta">August 01, 2025</p>
            </div>
          </Link>
        </article>

          <div className="blog-grid blog-list-grid">
            {posts.map((post) => (
              <article key={post.title} className="blog-card">
                <div className="blog-media">
                  <img src={post.image} alt={post.title} />
                </div>
                <div className="blog-body">
                  <p className="blog-meta">24.Oct.2025 | By Admin</p>
                  {post.path ? (
                    <h3>
                      <Link to={post.path}>{post.title}</Link>
                    </h3>
                  ) : (
                    <h3>{post.title}</h3>
                  )}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section about-contact">
        <div className="container about-contact-inner">
          <div className="about-contact-text">
            <h3 className="eyebrow">Get in</h3>
            <h3 className="about-heading">Touch</h3>
            <p>
              Have questions about investing in a Dhanvanti home? Share a few
              details and our team will get in touch.
            </p>
          </div>
          <div className="about-contact-card">
            <h4>Book a Site Visit Now</h4>
            <p className="contact-subtitle">Fill in the form.</p>
            <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
              <div className="form-row">
                <div className="form-field">
                  <input type="text" placeholder="First name" />
                </div>
                <div className="form-field">
                  <input type="text" placeholder="Last name" />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <input type="email" placeholder="Email address" />
                </div>
                <div className="form-field">
                  <input type="tel" placeholder="Phone" />
                </div>
              </div>
              <div className="form-field">
                <textarea
                  rows="3"
                  placeholder="Share any details you would like us to know."
                />
              </div>
              <div className="form-actions">
                <button type="submit" className="btn-primary">
                  Request to call back
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}

export default BlogListPage;

